import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import DateTimeField from "@/components/controls/DateTimeField";
import { FIELD_CLASSNAME, FOCUS_CLASSNAME } from "@/utils/fieldRendering/shared";
import { cn } from "@/utils/utils";

interface Props {
  value: string;
  onChange: (value: string) => void;
}

// Today or earlier applies immediately; a future date is held pending until the day.
const EffectiveDateSection: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  return (
    <div
      className="flex flex-col gap-1"
      data-test="update-terms-effective-date"
    >
      <Text variant="smSubtitle">
        {t("contracts.updateTerms.editor.effectiveDateTitle")}
      </Text>
      <Text variant="bodySecondary">
        {t("contracts.updateTerms.editor.effectiveDateSubtitle")}
      </Text>
      <div className="w-[300px] mt-3">
        <DateTimeField
          type="date"
          value={value}
          onChange={onChange}
          isOpen={isPickerOpen}
          onOpenChange={setIsPickerOpen}
          name="terms-effective-date"
          // The shared form-field styling, so the picker carries the same
          // hover and focus states as every other date field.
          className={cn(
            "w-full",
            FIELD_CLASSNAME,
            isPickerOpen && FOCUS_CLASSNAME
          )}
          showTodayLabel
        />
      </div>
    </div>
  );
};

export default EffectiveDateSection;
